import {forwardRef} from 'react'

import {IconMap} from '@defign/asset'
import {BiImage, isCard} from '@financial/common-bi'
import classNames from 'classnames/bind'

import InsuranceDetailButton from '$components/insurance/my/detail/InsuranceDetailButton'
import {무료보험_카테고리_아이콘} from '$constants/insurance/my/detail'

import Styles from './InsuranceDetailTitleInfo.module.scss'

import type {무료보험_카테고리} from '$share/constants/insurance'
import type {ValueOf} from 'next/constants'
import type {MouseEvent, ReactNode} from 'react'

const cx = classNames.bind(Styles)

interface TitleInfoArticleWrapperProps {
    children: ReactNode
    noTab?: boolean
}

export const InsuranceDetailTitleInfoArticleWrapper = ({children, noTab}: TitleInfoArticleWrapperProps) => {
    return <div className={cx('article', {'type-free': noTab})}>{children}</div>
}

export const InsuranceDetailTitleInfoListWrapper = forwardRef<HTMLDivElement, TitleInfoArticleWrapperProps>(
    ({children}, ref?) => {
        return (
            <div ref={ref} className={cx('list-area')}>
                <ul className={cx('list')}>{children}</ul>
            </div>
        )
    },
)

export const InsuranceDetailTitleInfoItemWrapper = ({children}: TitleInfoArticleWrapperProps) => {
    return <li className={cx('item')}>{children}</li>
}

interface InsuranceDetailTitleInfoSectionProps {
    company: string
    name: string
    orgCode?: string
    freeInsuCategory?: ValueOf<typeof 무료보험_카테고리>
}
export function InsuranceDetailTitleInfoSection({
    company,
    name,
    orgCode,
    freeInsuCategory,
}: InsuranceDetailTitleInfoSectionProps) {
    const Icon = freeInsuCategory ? 무료보험_카테고리_아이콘[freeInsuCategory] : IconMap

    return (
        <div className={cx('section')}>
            <span className={cx('bi')} style={{width: 50, height: 50, backgroundColor: '#ffffff'}}>
                {orgCode ? (
                    <BiImage
                        biId={{
                            mydataOrgCode: orgCode,
                        }}
                        type={
                            isCard({
                                mydataOrgCode: orgCode,
                            })
                                ? 'Plate'
                                : 'Profile'
                        }
                        id={`${orgCode}`}
                        width={50}
                    />
                ) : (
                    <Icon width={50} height={50} fill={'#fff'} />
                )}
            </span>

            <h3 className={cx('title')}>
                <span className={cx('company')}>{company}</span>
                <span className={cx('name')}>{name}</span>
            </h3>
        </div>
    )
}

interface InsuranceDetailButtonProps {
    text: string
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void
    nClkCode?: string
}

export function InsuranceDetailTitleInfo({text, onClick: handleClick, nClkCode}: InsuranceDetailButtonProps) {
    return (
        <InsuranceDetailTitleInfoItemWrapper>
            <InsuranceDetailButton text={text} onClick={handleClick} nClkCode={nClkCode} />
        </InsuranceDetailTitleInfoItemWrapper>
    )
}
